export default __webpack_public_path__ + "static/media/opensea-nft-logo.7c1d2d34.png";